import get from 'lodash.get';
import { TPricingPlans } from '../../S/pricing/types';
import { bitwiseRoundOff } from '../../Utils/CommonUtils';
import { CARD_COLOR_VALUE } from './cardDataConstant';
import { TCardData } from './pricing-card';

type TPricingCardForTable = {
  name: string;
  totalAmountInteger: number;
  originalAmountInteger: number;
  cardTitle: string;
  isBadgeExist: string;
  cardBadgeText: string;
  planType: string;
};

export const pricingCard = (
  cardData: TCardData,
  card: TPricingPlans,
  index: number
): TPricingCardForTable => {
  const planDetails = card.planDetails;
  const priceRangeData = cardData.priceRange[index];
  return {
    name: planDetails.name,
    totalAmountInteger: bitwiseRoundOff(
      get(planDetails, 'pricing.discountedPrice', 0)
    ),
    originalAmountInteger: bitwiseRoundOff(
      get(planDetails, 'pricing.listPrice', 0)
    ),
    cardTitle: get(priceRangeData, 'priceRange', ''),
    isBadgeExist: get(priceRangeData, 'badge.exist', ''),
    cardBadgeText: get(priceRangeData, 'badge.value', ''),
    planType: get(priceRangeData, 'planType', ''),
  };
};

export const cardColor = (cardBadgeText: string): string => {
  return cardBadgeText === 'GOLD'
    ? CARD_COLOR_VALUE.GOLD
    : cardBadgeText === 'PLATINUM'
    ? CARD_COLOR_VALUE.PLATINUM
    : '';
};
